export default "__VITE_ASSET__7bf39d62__"